import { formatEuro } from '../../helpers/formatCurrency';
import { Resource as ResourceType } from '../types';

export const expertInvoice: ResourceType = {
  name: 'expert_invoices',
  label: 'resource.invoices.label',
  hideResource: true,
  attributes: [
    {
      key: 'id',
      label: 'resource.invoices.field.id.label',
      type: 'text',
    },
    {
      key: 'company_name',
      label: 'resource.invoices.field.company_name.label',
      type: 'text',
    },
    {
      key: 'total_ttc',
      label: 'resource.invoices.field.total_ttc.label',
      type: 'number',
      showEuro: true,
    },
    {
      key: 'total_ht',
      label: 'resource.invoices.field.total_ht.label',
      type: 'number',
      showEuro: true,
    },
    {
      key: 'remaining_amount',
      label: 'remaining.amount.owed.label',
      type: 'number',
      showEuro: true,
    },
    {
      key: 'guid',
      label: 'resource.invoices.field.guid.label',
      type: 'text',
    },
    {
      key: 'pdfs',
      label: 'resource.invoices.field.pdfs.label',
      type: 'buttons',
    },
    {
      key: 'contract_id',
      label: 'resource.invoices.field.contract_id.label',
      type: 'reference',
      reference: 'contracts',
    },
    {
      key: 'contract_milestone_id',
      label: 'resource.invoices.field.contract_milestone_id.label',
      type: 'reference',
      reference: 'contract_milestones',
    },
    {
      key: 'due_date',
      label: 'resource.invoices.field.due_date.label',
      type: 'date',
    },
    {
      key: 'user_kind',
      label: 'resource.invoices.field.user_kind.label',
      type: 'select',
      choices: [
        {
          id: 'expert',
          name: 'resource.invoices.field.user_kind.choices.expert.label',
        },
        {
          id: 'client',
          name: 'resource.invoices.field.user_kind.choices.client.label',
        },
      ],
    },
    {
      key: 'status',
      label: 'resource.invoices.field.status.label',
      type: 'select',
      choices: [
        {
          id: 'proforma',
          name: 'resource.invoices.field.status.choices.proforma.label',
        },
        {
          id: 'created',
          name: 'resource.invoices.field.status.choices.created.label',
        },
        {
          id: 'partial_payment',
          name: 'resource.invoices.field.status.choices.partialpayment.label',
        },
        {
          id: 'payed',
          name: 'resource.invoices.field.status.choices.payed.label',
        },
      ],
    },
    {
      key: 'created_at',
      label: 'resource.invoices.field.created_at.label',
      type: 'date',
    },
    {
      key: 'updated_at',
      label: 'resource.invoices.field.updated_at.label',
      type: 'date',
    },
    {
      key: 'mission_id',
      label: 'resource.invoices.field.mission_id.label',
      type: 'reference',
      reference: 'missions',
    },
    {
      key: 'proposal_id',
      label: 'resource.invoices.field.proposal_id.label',
      type: 'reference',
      reference: 'proposals',
    },
    {
      key: 'company_id',
      label: 'resource.invoices.field.company_id.label',
      type: 'reference',
      reference: 'companies',
    },
    {
      key: 'company_id',
      label: 'resource.invoices.field.client_company_id.label',
      type: 'reference',
      reference: 'companies',
    },
    {
      key: 'owner_id',
      type: 'reference',
      reference: 'users',
    },
    {
      key: 'client_owner_id',
      type: 'reference',
      reference: 'users',
    },
    {
      key: 'contract_milestone',
      type: 'object',
      shape: [
        {
          key: 'payment_period',
          label: 'resource.contract_milestones.field.payment_period.label',
          type: 'select',
          choices: [
            {
              id: 'payment_client',
              name: 'resource.contract_milestones.field.payment_period.choices.payment_client.label',
            },
            {
              id: 'ten_days',
              name: 'resource.contract_milestones.field.payment_period.choices.ten_days.label',
            },
          ],
        },
        {
          key: 'discount',
          label: 'resource.proposals.field.discount.label',
          type: 'number',
        },
        {
          key: 'vat',
          label: 'resource.contract_milestones.field.vat.label',
          type: 'number',
        },
        {
          key: 'professional_indemnity_percentage',
          label:
            'resource.proposals.field.professional_indemnity_percentage.label',
          type: 'number',
        },
        {
          key: 'professional_indemnity',
          label: 'resource.proposals.field.professional_indemnity.label',
          type: 'boolean',
        },
      ],
    },
    {
      key: 'billing_date',
      type: 'date',
      label: 'resource.invoices.field.invoices_at.label',
    },
    {
      key: 'payment_date',
      type: 'date',
      label: 'resource.invoices.field.payment_date.label',
    },
  ],
  pages: {
    list: {
      hasEditButton: true,
      editAndCreateBasePath: '/invoices',
      search: {
        enabled: true,
        label: 'filter.search.label',
      },
      bulkActionButtons: [
        {
          name: 'validate',
          type: 'update',
          label: 'resource.invoices.bulk_action_buttons.validate.label',
          values: {
            validated: true,
          },
        },
      ],
      filters: [
        {
          source: 'status',
          type: 'multipleSelect',
          optionsFilter: {
            className: 'multipleSelectFilter',
          },
        },
        {
          name: 'company_id',
          type: 'reference',
          reference: 'companies',
          label: 'resource.invoices.field.company_id.label',
          filter: { user_kind: 'expert' },
          child: {
            type: 'autocomplete',
            optionText: 'name',
            options: {
              perPage: 10,
              allowEmpty: false,
            },
          },
        },
        {
          source: 'billing_date',
          type: 'dateRange',
          label: 'resource.invoices.field.invoices_at.label',
        },
        {
          source: 'payment_date',
          type: 'dateRange',
          label: 'resource.invoices.field.payment_date.label',
        },
      ],
      fields: [
        {
          source: 'guid',
          style: {
            whiteSpace: 'nowrap',
            overflowWrap: 'break-word',
          },
        },
        {
          source: 'company_name',
        },
        {
          source: 'status',
          style: {
            whiteSpace: 'nowrap',
            overflowWrap: 'break-word',
          },
        },
        {
          source: 'billing_date',
        },
        {
          source: 'payment_date',
        },
        {
          source: 'due_date',
        },
        {
          source: 'total_ht',
        },
        {
          source: 'total_ttc',
        },
        {
          source: 'remaining_amount',
        },
        {
          source: 'contract_milestone_id',
          child: {
            source: 'contract_milestones.title',
          },
        },
        {
          source: 'pdfs',
          sortable: false,
          extensions: [
            {
              key: 'multipleLangFiles',
            },
          ],
        },
        {
          source: 'created_at',
        },
      ],
    },
    edit: {
      actions: [],
      left: {
        tabs: [],
      },
      right: [
        {
          sections: [],
        },
      ],
    },
  },
};
